import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import * as _ from 'lodash';
import { AppSidebar, Sidebar, SidebarLayout } from '../models/sidebar';


@Injectable({
  providedIn: 'root'
})
export class SidebarService implements OnDestroy {
  public sidebars: BehaviorSubject<Sidebar> = new BehaviorSubject<Sidebar>({
    apps: {},
    current: null,
    open: false
  });
  public defaultLayout: SidebarLayout = {
    width: 30,
    position: 'right-top-x',
    height: 'auto'
  };

  constructor() {
    console.log(' SIDEBAR MANAGER CONSTRUCTOR ');
  }

  // * Obtener el estado de un sidebar.
  isOpen = (name: string): boolean => {
    const apps = this.sidebarsRef.apps;
    return apps[name]?.open.value;
  }

  // * Visualiza un sidebar dado su nombre y si tiene datos de entrada.
  open = (name: string, input = null): void => {
    const sidebars = this.sidebarsRef;
    const sidebar = sidebars.apps[name];
    sidebar.open = new BehaviorSubject<boolean>(true);
    sidebar.close = new BehaviorSubject<boolean>(false);
    sidebar.data.input = input;
    this.sidebars.next(sidebars);
  }

  // * Cierra un sidebar dado su nombre y si tiene datos a devolver.
  close = (name: string, output = null): void => {
    const sidebars = this.sidebarsRef;
    const sidebar = sidebars.apps[name];
    sidebar.data.output = output;

    this.sidebars.next(sidebars);
    sidebar.open.next(false);
    sidebar.close.next(true);

    delete sidebar.close;
    delete sidebar.open;
  }

  // * Se establece la lista de sidebars a manejar.
  setSidebars = (list: AppSidebar[]): void => {
    const sidebars = this.sidebarsRef;
    this.sidebars = new BehaviorSubject<Sidebar>({
      apps: {},
      current: null,
      open: false
    });
    list.forEach((item: AppSidebar) => {
      const app: AppSidebar = {
        /* open: new BehaviorSubject<boolean>(false),
        close: new BehaviorSubject<boolean>(false), */
        title: item.title,
        layout: Object.assign(_.cloneDeep(this.defaultLayout), item.layout),
        data: {
          output: null,
          input: null
        }
      };
      sidebars.apps[item.name] = app;
    });
    this.sidebars.next(sidebars);
  }

  // * Observa el estado de un sidebar, devolviendo una data siendo el caso.
  afterClosed = (sidebar: string): Observable<any> => {
    return this.getSidebarData(sidebar).close.pipe(
      filter((status: boolean) => status), // * Filtrar solo si close === true;
      map(() => this.getOutput(sidebar))  // * Devuelve el output del evento close.
    );
  }

  // * Obtiene la data de salida de un sidebar.
  getOutput = (sidebar: string): any => {
    return this.getSidebarData(sidebar).data?.output;
  }

  // * Obtiene la data de salida de un sidebar.
  getInput = (sidebar: string): any => {
    return this.getSidebarData(sidebar).data?.input;
  }

  // * Obtiene los datos de un sidebar dado su nombre.
  getSidebarData = (name: string): AppSidebar => {
    return this.sidebarsRef.apps[name];
  }

  get sidebarsRef(): Sidebar {
    return this.sidebars.value;
  }

  ngOnDestroy(): void { }
}
